<script>
    import { personalizeText, getColor } from '$lib/helper';
    import { onMount } from 'svelte';

    export let content = {};
    export let childComponents = [];
    export let transitionDelay = 0;
    export let transitionEffect = 'none';
    export let campaignId = '';
    export let trackingProperties = [];
    export let theme = {};
    export let language = 'de';

    let Accordion;

    // Dynamic import
    onMount(async () => {
        Accordion = (await import('$lib/components/_DisplayComponents/Accordion/Accordion.svelte'))
            .default;
    });

    const items = childComponents.map((item) => {
        const title = item.components[0];
        const body = item.components[1];

        return {
            bgColor: item.content.box.backgroundColor,
            title: {
                draft: personalizeText(
                    title.content.wysiwyg,
                    trackingProperties,
                    campaignId,
                    language,
                ),
                color: getColor(title.content.color, theme.fontColor),
                linkColor: theme.buttonBackgroundColor,
            },
            body: {
                draft: body.content.wysiwyg,
                color: getColor(body.content.color, theme.fontColor),
                linkColor: theme.buttonBackgroundColor,
            },
        };
    });
</script>

<svelte:component this={Accordion} {items} {transitionDelay} {transitionEffect} box={content.box} />
